// Existing journals keep their entry flow. Accounts created from this release
// date complete their atmosphere and first tour even after refreshing setup.
export const FIRST_JOURNEY_START = Date.UTC(2026,9,14);
export const isFirstJourneyAccount = user => {
  const created = Date.parse(user?.metadata?.creationTime || '');
  return Number.isFinite(created) && created >= FIRST_JOURNEY_START;
};
